/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import CustomersTable from '../../modules/Tahsilat/Content/CustomersTable'
import CustomerFilter from '../../modules/Tahsilat/Content/CustomerFilter'
import ModalCard from '../../modules/Tahsilat/modal/ModalCard'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {changeModalVisibility} from '../../../setup/slices/ModalSlice'
import {getActivityInfo, getWorkInCustomerId} from '../../helper/ActivityHelper'
import {GetAdminTahsilatCustomers, GetCustomers} from '../../modules/AnaVezne/apis/ApiCall'
import AuthService from '../../modules/auth/redux/AuthService'
import '../../styles/Modal.css'
import moment from 'moment'

const Tahsilat: React.FC = () => {
  const [customer, setCustomer] = useState<any>()
  const [workInCustomerId, setWorkInCustomerId] = useState<string>('')
  const [activityInfo, setActivityInfo] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [customerList, setCustomerList] = useState<any>({Status: 'NONE', Detail: []})
  const [searchText, setSearchText] = useState<string>('')
  const [message, setMessage] = useState<string>('')
  const [filteredCustomers, setFilteredCustomers] = useState<any[]>([])

  const [todayPayment, setTodayPayment] = useState<boolean>(false)
  const [delayedPayment, setDelayedPayment] = useState<boolean>(false)
  const [todayRecall, setTodayRecall] = useState<boolean>(false)
  const [passedExpiry, setPassedExpiry] = useState<boolean>(false)

  const user = AuthService.GetCurrentUser()
  const isAdmin =
    user.userData?.roles?.some((element: string) => element === 'Anavezne Admin') || false

  const dispatch = useDispatch()
  const isVisible = useSelector((state: RootState) => state.isVisible.isVisible)

  useEffect(() => {
    getWorkInCustomerId(setWorkInCustomerId, user.userData?.salesPersonGuid)
  }, [user.userData?.salesPersonGuid])
  console.log('workInCustomerId', filteredCustomers)

  useEffect(() => {
    if (customerList !== undefined) {
      setFilteredCustomers(
        customerList.Detail.filter((customer: any) => {
          if (customer.CustName !== null) {
            return customer.CustName.toUpperCase().includes(searchText.toUpperCase())
          }
        })
      )
    }
    if (customerList !== undefined) {
      if (customerList.Status === 'SUCCESS') {
        if (
          todayPayment === false &&
          delayedPayment === false &&
          todayRecall === false &&
          passedExpiry === false
        ) {
          setFilteredCustomers(customerList.Detail)
        } else if (todayPayment || delayedPayment || todayRecall || passedExpiry) {
          let todayFilter = []
          let delayedFilter = []
          let recallFilter = []
          let expiryFilter = []

          if (todayPayment) {
            todayFilter = customerList.Detail.filter((customer: any) => {
              if (customer.OdemeTarihi !== null) {
                if (customer.OdemeTaihi !== '') {
                  if (
                    customer.OdemeTarihi === moment(new Date()).format('YYYY-MM-DD').split('T')[0]
                  ) {
                    return customer
                  }
                }
              }
              return
            })
          }

          if (delayedPayment) {
            delayedFilter = customerList.Detail.filter((customer: any) => {
              if (customer.TotalOverDue > 0) {
                return customer
              }
              return
            })
          }

          if (todayRecall) {
            recallFilter = customerList.Detail.filter((customer: any) => {
              if (customer.AramaTarihi !== undefined) {
                if (customer.AramaTarihi !== '') {
                  if (
                    customer.AramaTarihi === moment(new Date()).format('YYYY-MM-DD').split('T')[0]
                  ) {
                    return customer
                  }
                }
              }
            })
          }

          if (passedExpiry) {
            expiryFilter = customerList.Detail.filter((customer: any) => {
              if (customer.OdemeTarihi !== undefined) {
                if (customer.OdemeTarihi !== '') {
                  if (
                    customer.OdemeTarihi > moment(new Date()).format('YYYY-MM-DD').split('T')[0]
                  ) {
                    return
                  } else {
                    return customer
                  }
                } else {
                  return customer
                }
              }
            })
          }

          let arr = [...todayFilter, ...delayedFilter, ...recallFilter, ...expiryFilter]
          let newArr = arr.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.CustomerId === value.CustomerId)
          )
          setFilteredCustomers(newArr)
        }
      }
    }
  }, [
    todayPayment,
    delayedPayment,
    todayRecall,
    passedExpiry,
    customerList,
    user.userData?.salesPersonGuid,
  ])

  useEffect(() => {
    if (customerList !== undefined) {
      if (customerList.Status === 'SUCCESS') {
        setFilteredCustomers(customerList.Detail)
      }
    }
  }, [customerList])

  useEffect(() => {
    dispatch(changeModalVisibility(false))
    getActivityInfo(setActivityInfo)
  }, [])

  useEffect(() => {
    if (!isAdmin) {
      setIsLoading(true)
      GetCustomers(setCustomerList, setIsLoading, workInCustomerId)
    } else {
      setIsLoading(false)
    }
  }, [workInCustomerId])

  useEffect(() => {
    if (!isAdmin) {
      if (filteredCustomers.length < 1 && !isLoading && filteredCustomers.length === 0) {
        setIsLoading(false)
        setMessage('Müşteri Bulunamadı')
      }
    }
  }, [filteredCustomers, searchText, isLoading])

  useEffect(() => {
    if (customerList !== undefined) {
      setFilteredCustomers(customerList.Detail)
      if (isAdmin) {
        if (searchText.length > 3) {
          setIsLoading(true)
          GetAdminTahsilatCustomers(searchText, setCustomerList, setIsLoading)
        } else if (searchText.length === 0) {
          setIsLoading(false)
          setCustomerList({Status: 'LOADING', Detail: []})
          setMessage('Müşterileri Görmek İçin Arama Yapın.')
        }
      } else {
        if (searchText.length > 0) {
          setFilteredCustomers(
            customerList.Detail.filter((customer: any) => {
              if (
                customer.CustName !== null &&
                customer.CustName.toUpperCase().includes(searchText.toUpperCase())
              ) {
                return true
              }
              if (
                customer.Customerreference !== null &&
                customer.Customerreference.toUpperCase().includes(searchText.toUpperCase())
              ) {
                return true
              }
              if (
                customer.VergiNo !== null &&
                customer.VergiNo.toUpperCase().includes(searchText.toUpperCase())
              ) {
                return true
              }
              return false
            })
          )
        }
      }
    }
  }, [searchText])

  return (
    <>
      {isVisible ? <ModalCard customer={customer} activityInfo={activityInfo} /> : <></>}

      <div className='card card-xxl-stretch mb-5 mb-xl-8' style={{zIndex: 1}}>
        <div>
          {!isAdmin && (
            <div className='card-body text-dark fs-5' style={{backgroundColor: '#e4e6ef'}}>
              <CustomerFilter
                setTodayPayment={setTodayPayment}
                setDelayedPayment={setDelayedPayment}
                setTodayRecall={setTodayRecall}
                setPassedExpiry={setPassedExpiry}
              />
            </div>
          )}

          <CustomersTable
            setCustomer={setCustomer}
            isLoading={isLoading}
            customerList={filteredCustomers}
            isAdmin={isAdmin}
            setSearchText={setSearchText}
            message={message}
            workInCustomerId={workInCustomerId}
          />
        </div>
      </div>
    </>
  )
}

export {Tahsilat}
